import { createAppSlice } from '../../app/createAppSlice'

const initialState = {
    updatedResources: [],
    status: "empty"  //or "hasChanges"
}

const changedResourcesListSlice = createAppSlice({
    name: "changedResourcesList",
    initialState,
    reducers: create => ({
        changedResourceAdded: create.reducer((state, action) => {
            //action.payload = {singleUpdate: "FOI" || null, multipleUpdate: ["FOI", "FOI"] || null}
            if (action.payload.singleUpdate &&
                !state.updatedResources.includes(action.payload.singleUpdate)) {
                state.updatedResources.push(action.payload.singleUpdate)
            }
            if (action.payload.multipleUpdate) {
                let multipleUpdate = action.payload.multipleUpdate;
                if (Array.isArray(multipleUpdate) && multipleUpdate.length) {
                    for (const foi of multipleUpdate) {
                        if (!state.updatedResources.includes(foi)) {
                            state.updatedResources.push(foi)
                        }
                    }
                }
            }
            state.status = "hasChanges"
        }),
        changesCleared: create.reducer((state) => {
            state.updatedResources = []
            state.status = "empty"
        }),
    }),
    selectors: {
        selectChangedResourcesListStatus: changedResourcesList => changedResourcesList.status,
        selectChangedResourcesList: changedResourcesList => changedResourcesList.updatedResources
    },
})

export const { changedResourceAdded, changesCleared } = changedResourcesListSlice.actions

export const { selectChangedResourcesListStatus, selectChangedResourcesList } = changedResourcesListSlice.selectors

export default changedResourcesListSlice